import gql from 'graphql-tag';

// INFO: Asegurarse de al aplicar un cambio en la query updateProductMutation, replicarlo en updateProductWithAttributesMutation
export const updateProductMutation = gql`
  mutation UpdateItem($itemId: uuid!, $data: item_set_input!) {
    update_item(where: {id: {_eq: $itemId}}, _set: $data) {
      returning {
        __typename
        id
        sku
        code
        name
        description
        catalog_id
        currency
        price
        uom
        manufacturer
        manufacturer_partnumber
        published_at
        has_stock
        is_obsolete
        is_active
        category_id
        image
        attached_file
        taxonomy_category {
          mdm_code
          mdm_name
        }
        noun
        modifier
        item_attribute_values {
          item_id
          attribute_id
          mdm_value
          taxonomy_attribute {
            mdm_code
            mdm_name
            mdm_order
            is_required
          }
        }
        technical_specification
        item_equivalents{
          id
          manufacturer
          part_number
          item_id
          created_at
        }
      }
      affected_rows
      __typename
    }
  }
`;

export const updateProductWithAttributesMutation = gql `
mutation UpdateItem($itemId: uuid!, $data: item_set_input!, $attributes: [item_attribute_value_insert_input!]!, $item_equivalents: [item_equivalent_insert_input!]!, $deleted_ids: [uuid!]) {
  delete_item_attribute_value(where: {item_id: {_eq: $itemId}}) {
    affected_rows
  }
  insert_item_attribute_value(objects: $attributes) {
    affected_rows
    __typename
  }
  insert_item_equivalent(objects: $item_equivalents, on_conflict: {constraint: item_equivalent_pkey, update_columns: [deleted_at], where: {id: {_in: $deleted_ids}}}) {
    affected_rows
  }
  update_item(where: {id: {_eq: $itemId}}, _set: $data) {
    returning {
      __typename
      id
      sku
      code
      name
      description
      catalog_id
      currency
      price
      uom
      manufacturer
      manufacturer_partnumber
      published_at
      has_stock
      is_obsolete
      is_active
      category_id
      image
      attached_file
      taxonomy_category {
        mdm_code
        mdm_name
      }
      noun
      modifier
      item_attribute_values {
        item_id
        attribute_id
        mdm_value
        taxonomy_attribute {
          mdm_code
          mdm_name
          mdm_order
          is_required
        }
      }
      technical_specification
      item_equivalents{
        id
        manufacturer
        part_number
        item_id
        created_at
      }
    }
    affected_rows
    __typename
  }
}
`;

export const insertProductMutation = gql`
  mutation InsertItem($data: [item_insert_input!]!) {
    insert_item(objects: $data) {
      returning {
        __typename
        id
        sku
        code
        name
        description
        catalog_id
        currency
        price
        uom
        manufacturer
        manufacturer_partnumber
        published_at
        has_stock
        is_obsolete
        is_active
        category_id
        taxonomy_category {
          mdm_code
          mdm_name
        }
        noun
        modifier
        item_attribute_values {
          item_id
          attribute_id
          mdm_value
          taxonomy_attribute {
            mdm_code
            mdm_name
            mdm_order
            is_required
          }
        }
        technical_specification
        item_equivalents{
          item_id
          manufacturer
          part_number
        }
        image
        attached_file
      }
      affected_rows
      __typename
    }
  }
`;

export const updateUserMutation = gql`
  mutation updateUser($userId: uuid!, $data: user_set_input!) {
    update_user(where: { id: { _eq: $userId } }, _set: $data) {
      returning {
        __typename,
        id
        user_name
        email
        first_name
        last_name
        activated_at
        locked_at
        created_at
      }
      affected_rows
    }
  }
`;

export const SSOUpdateUserPassword = gql `mutation UpdateUserPassword($password: UserChangePasswordApiDto_String_Input){
  sso_update_user_password(password: $password)
}`;

export const updateOrganizationMutation = gql `
  mutation updateOrganization(
    $organizationId: uuid!, 
    $organization_set: organization_set_input!
  ){
    update_organization(where: {id: { _eq: $organizationId }}, _set: $organization_set) {
      affected_rows
      returning {
        id
        name
        description
        website
        tax_id
        contact_name
        contact_email
        country
        city
        address
        created_date
        last_billing
      }
    }
  }`
  ;



// WEBPACK FOOTER //
// ./src/store/graphql/mutations/_admin-catalog.js